
export default {
	IsPC() {
    var userAgentInfo = navigator.userAgent;
    var Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPod"];
    var flag = true;
    for (var v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
        flag = false;
        break;
      }
    }
    return flag;
  },
	textRepl(str){
		let reple = process.env.VUE_APP_IMAGEURLRPLE 
		let url = process.env.VUE_APP_IMAGEURL 
		let newstr = str.replaceAll(reple, url + reple)
		return newstr
	},
	imgTrow(str,ISSDK = false){
		let url = !ISSDK ? process.env.VUE_APP_IMAGEURL  : process.env.VUE_APP_SDKIMAGEURL
		return  url + str
	},
  formatDateTime(timeStamp, dateType) {
    dateType = dateType || "YY-MM-DD"; // 默认转换格式
    var date = new Date();
    date.setTime(timeStamp * 1000);
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? "0" + m : m;
    var d = date.getDate();
    d = d < 10 ? "0" + d : d;
    var h = date.getHours();
    h = h < 10 ? "0" + h : h;
    var minute = date.getMinutes();
    var second = date.getSeconds();
    minute = minute < 10 ? "0" + minute : minute;
    second = second < 10 ? "0" + second : second;
    if (dateType == "YY-MM-DD") {
      return y + "-" + m + "-" + d;
    } else if (dateType == "YY-MM-DD HH:II:SS") {
      return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second;
    } else if (dateType == "HH:II:SS") {
      return h + ":" + minute + ":" + second;
    } else if (dateType == "HH:II") {
      return h + ":" + minute;
    } else if (dateType == "MM-DD") {
      return m + "-" + d;
    } else {
      console.error("时间戳转换失败！");
    }
  },
}
